<section class="container">
  @if (!loading) {
  <div>
    @if (isReloadAvailable) {
    <div class="tools-right">
      <button
        avButton
        ofType="basic"
        class="fx-row fx-align-center"
        (click)="getInteractions()"
      >
        <av-icon size="xs" name="reload"></av-icon>
        {{ "Refresh" | translate }}
      </button>
    </div>
    } @if (isInitialized) {
    <div class="step text-center">
      <div class="panel-container">
        @if (isHelpVisible) {
        <av-card type="info">
          <av-card-body size="xs">
            <h3 class="container-pad-md" translate>
              Please enable one of the available actions in the settings page.
            </h3>
          </av-card-body>
        </av-card>
        }
        <!-- schedule -->
        <div class="panel-container-secondary">
          @if (isSchedulingAvailable) { @if (isActiveActionEmpty()) {
          <av-tooltip
            [message]="
              isSchedulingNotConfigured
                ? 'Go to settings to configure'
                : 'Schedule a video call'
            "
            position="top"
            [class.panel-button-callback]="
              isVideoCallAvailable ||
              isCobrowseAvailable ||
              isScreenShareAvailable
            "
          >
            <button
              [disabled]="isSchedulingDisabled"
              class="launch-button"
              [attr.aria-label]="'Schedule a video call' | translate"
              (click)="toggleCallback()"
              data-tid="welcome/launch-callback"
              id="btn-callback"
              (mousedown)="onMouseDown('calendar')"
              (mouseup)="onMouseUp()"
              (mouseleave)="onMouseUp()"
            >
              <div class="launch-button-body">
                <av-icon
                  [mode]="iconActive() === 'calendar' ? 'light' : 'dark'"
                  name="calendar-time-thin"
                ></av-icon>
              </div>
            </button>
          </av-tooltip>
          } @if (isCallbackVisible()) {
          <app-callback
            [inCall]="false"
            [hover]="false"
            (close)="toggleCallback()"
          >
          </app-callback>
          } } @if (isAssistantAvailable()) { @if (isActiveActionEmpty()) {
          <av-tooltip
            message="AI Agent"
            position="bottom"
            [class.panel-button-assistant]="
              isVideoCallAvailable ||
              isCobrowseAvailable ||
              isScreenShareAvailable
            "
          >
            <button
              class="launch-button"
              [attr.aria-label]="'AI Agent' | translate"
              (click)="openAssistant()"
              data-tid="welcome/launch-assistant"
              (mousedown)="onMouseDown('assistant')"
              (mouseup)="onMouseUp()"
              (mouseleave)="onMouseUp()"
            >
              <div class="launch-button-body">
                <av-icon
                  [mode]="iconActive() === 'assistant' ? 'light' : 'dark'"
                  name="assistant"
                ></av-icon>
              </div>
            </button>
          </av-tooltip>
          } }
        </div>
        <!-- <button (click)="test()">
            test chat message
          </button> -->
        <!-- audio/video call -->
        @if (isActiveActionEmpty() && isVideoCallAvailable) {
        <button
          [class.ripple-container]="isCallEnabled"
          class="launch-button"
          [disabled]="!isCallEnabled"
          data-tid="welcome/launch-conference"
          [attr.aria-label]="'Start a video call' | translate"
          (click)="startCall()"
          (mousedown)="onMouseDown('call')"
          (mouseup)="onMouseUp()"
          (mouseleave)="onMouseUp()"
          #callBtn
          autofocus
        >
          <div class="launch-button-body" id="btn-generate-room-and-join">
            @if (!isCallLoading()) { @if (!isConversationAudio) {
            <av-icon
              [mode]="iconActive() === 'call' ? 'light' : 'dark'"
              name="cam"
            ></av-icon>
            } @if (isConversationAudio) {
            <av-icon
              [mode]="iconActive() === 'call' ? 'light' : 'dark'"
              name="mic"
            ></av-icon>
            } } @if (isCallLoading()) {
            <av-spinner size="md" mode="dark"></av-spinner>
            }
          </div>
        </button>
        }
        <div class="panel-container-secondary">
          <!-- cobrowse -->
          @if (isCobrowseAvailable) { @if (isActiveActionEmpty()) {
          <av-tooltip
            position="bottom"
            [class.panel-button-cobrowse]="isVideoCallAvailable"
            message="Start a co-browse session"
          >
            <button
              class="launch-button"
              [disabled]="isCobrowseDisabled"
              (click)="toggleCobrowse()"
              data-tid="welcome/launch-cobrowse"
              [attr.aria-label]="'Start a co-browse session' | translate"
              autofocus
              (mousedown)="onMouseDown('cobrowse')"
              (mouseup)="onMouseUp()"
              (mouseleave)="onMouseUp()"
            >
              <div
                class="launch-button-body"
                id="btn-cobrowse"
                data-tid="welcome/launch-cobrowse"
              >
                <av-icon
                  name="cobrowse"
                  [mode]="iconActive() === 'cobrowse' ? 'light' : 'dark'"
                ></av-icon>
              </div>
            </button>
          </av-tooltip>
          } }
          <!-- screen share -->
          @if (isScreenShareAvailable) { @if (isActiveActionEmpty()) {
          <av-tooltip
            position="bottom"
            [class.panel-button-display-capture]="isVideoCallAvailable"
            message="Start a Screen Share session"
          >
            <button
              class="launch-button"
              [disabled]="isCobrowseDisabled"
              (click)="toggleDisplayCapture()"
              data-tid="welcome/launch-display-capture"
              [attr.aria-label]="'Start a Screen Share session' | translate"
              autofocus
              (mousedown)="onMouseDown('display-capture')"
              (mouseup)="onMouseUp()"
              (mouseleave)="onMouseUp()"
            >
              <div
                class="launch-button-body"
                id="btn-display-capture"
                data-tid="welcome/launch-display-capture"
              >
                <av-icon
                  name="cobrowse-screen"
                  [mode]="iconActive() === 'display-capture' ? 'light' : 'dark'"
                ></av-icon>
              </div>
            </button>
          </av-tooltip>
          } }
        </div>
        @if (isAssistantOpen()) {
        <app-assistant-launcher
          (dismiss)="assistantClosed()"
        ></app-assistant-launcher>
        } @if ( (isCobrowseAvailable || isScreenShareAvailable) &&
        isCobrowseVisible() ) {
        <app-cobrowse-launcher
          [interaction]="interaction()"
          [requestType]="cobrowseRequestType()"
          (started)="cobrowseStarted($event)"
          (closed)="cobrowseCancelled()"
        ></app-cobrowse-launcher>
        }
      </div>
      @if (isActiveActionEmpty()) { @if (isOriginCall || isOriginChat ||
      isOriginInteractionWidget) {
      <h1 class="title" translate>Click to create a video room</h1>
      <h3 translate>You can invite the customer once you join</h3>
      } @if (isOriginWidget && !isConversationCallback) { @if
      (!isConversationChat) {
      <h1 translate>Hurry up! The customer is waiting.</h1>
      @if (isVideoCallAvailable) { @if (isConversationVideo) {
      <h1 class="title" translate>Click to join the video room</h1>
      } @if (isConversationAudio) {
      <h1 class="title" translate>Click to join the Voice call</h1>
      } } @if (!isVideoCallAvailable) { @if (isCobrowseAvailable) {
      <h3 translate>Start a co-browse session</h3>
      } @if (isScreenShareAvailable) {
      <h3 translate>Start a Screen Share session</h3>
      } } @if (isVideoCallAvailable) {
      <h3 translate>The customer will join once you join</h3>
      } } @if (isConversationChat) { @if (isVideoCallAvailable) {
      <h1 translate>Click to escalate this chat session to Video Call</h1>
      } @if (isCobrowseAvailable && !isVideoCallAvailable) {
      <h1 translate>Escalate chat to Co-browse</h1>
      } @if (isScreenShareAvailable && !isVideoCallAvailable) {
      <h1 translate>Escalate chat to Screen Share</h1>
      }
      <h3 translate>The customer will join once you join</h3>
      } } @if (isConversationCallback) {
      <h1 class="title" translate>Click to join the scheduled video call</h1>
      <h3 translate>The customer is already waiting for you</h3>
      } @if (!isInteractionAvailable) {
      <h1 class="title">
        <span translate>Hello</span>&nbsp;@if (!!user) {
        <span>{{ name }}</span>
        }
      </h1>
      @if (isVideoCallAvailable) {
      <h3 translate>Waiting for the next customer...</h3>
      } @if (!isVideoCallAvailable) { @if (isCobrowseAvailable) {
      <h3 translate>Start a co-browse session</h3>
      } @if (isScreenShareAvailable) {
      <h3 translate>Start a Screen Share session</h3>
      } } @if ( !isVideoCallAvailable && !isCobrowseAvailable &&
      isSchedulingAvailable ) {
      <h3 translate>Schedule a video call</h3>
      } } @if (isOriginAppointment) {
      <h1 class="title" translate>Click to join the appointment</h1>
      <h3 translate>The customer is already waiting for you</h3>
      } }
    </div>
    }
  </div>
  }
</section>
